
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    btns: {
      type: Array,
      default: [],
    },
  },
  emits: ["close"],
  setup(_, { emit }) {
    const close = () => {
      emit("close");
    };
    return {
      close,
    };
  },
});
